module.exports = __webpack_public_path__ + "img/loading.88b4dbc9.svg";